import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { ECampaignRoutes } from 'src/modules/jobs/routes.enum'

/**
 * @deprecated
 */
export const useIsAtGuestOnboarding = () => {
  const location = useLocation()

  const isAtGuestOnboarding = useMemo(() => {
    return location.pathname.startsWith(ECampaignRoutes.CAMPAIGNS_PUBLIC_ONBOARDING)
  }, [location])

  return isAtGuestOnboarding
}
